/**
 * 결제 실패 알림
 * FSD: features/subscription/subscription-manage/ui
 */

import React from 'react';
import type { Subscription } from '@/entities/subscription/model';
import { formatDate } from '@/shared/lib/payment/format-amount';

interface PaymentFailureAlertProps {
  subscription: Subscription;
  onRetry?: () => void;
}

export const PaymentFailureAlert: React.FC<PaymentFailureAlertProps> = ({
  subscription,
  onRetry,
}) => {
  if (!subscription.last_payment_failed_date) {
    return null;
  }

  return (
    <div className="payment-failure-alert">
      <div className="alert-header">
        <span className="alert-icon">⚠️</span>
        <h3>결제 실패</h3>
      </div>

      <div className="alert-body">
        <p>
          마지막 결제 실패: <strong>{formatDate(subscription.last_payment_failed_date)}</strong>
        </p>
        <p>오류: {subscription.last_payment_error}</p>
        <p>
          재시도 횟수: <strong>{subscription.retry_count || 0}/3</strong>
        </p>
        <p className="alert-text">
          3회 재시도 후에도 결제되지 않아 구독이 일시중지되었습니다.
          재개 버튼을 클릭하여 다시 시도해주세요.
        </p>
      </div>

      {onRetry && (
        <div className="alert-footer">
          <button onClick={onRetry} className="retry-button">
            구독 재개하기
          </button>
        </div>
      )}
    </div>
  );
};
